<script lang="ts">
	import childrenImage3Xl from "@assets/images/fathers-family-children.jpg?webp&imagetools";
	import childrenImageXs from "@assets/images/fathers-family-children.jpg?webp&w=800&imagetools";
	import childrenImageSm from "@assets/images/fathers-family-children.jpg?webp&w=960&imagetools";
	import childrenImage2Xl from "@assets/images/fathers-family-children.jpg?webp&w=2400&imagetools";
	import wholesaleImage3Xl from "@assets/images/wholesale.jpg?webp&imagetools";
	import wholesaleImageXs from "@assets/images/wholesale.jpg?webp&w=800&imagetools";
	import wholesaleImageSm from "@assets/images/wholesale.jpg?webp&w=960&imagetools";
	import wholesaleImage2xl from "@assets/images/wholesale.jpg?webp&w=2400&imagetools";
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import ImageSection from "@components/sections/ImageSection.svelte";
	import { Auth } from "@utils/Auth.svelte.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import { AuthenticationModalKind } from "@core/schema/AuthenticationModalKind.js";
	import { getJoinWholesaleAnchor } from "@core/schema/paths/getJoinWholesaleAnchor.js";
	import { getMembershipPagePath } from "@core/schema/paths/getMembershipPagePath.js";
	import { getWholesalePath } from "@core/schema/paths/getWholesalePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./IntroSections.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<div class="grid grid-cols-1 lg:grid-cols-2 full-width">
	<ImageSection
		class="w-full !h-[75vh] lg:!col-span-1 px-0"
		sources={{ default: childrenImageXs, ">sm": childrenImageSm, ">2xl": childrenImage2Xl, ">3xl": childrenImage3Xl }}
		heading={{ text: translate("fathersFamily"), level: 2 }}
		paragraph={translate("fathersFamilyInfo")}
		media="object-[50%_40%]"
		innerClass="px-0"
		darkOverlay
	>
		{#snippet actions()}
			<Link size={ButtonSize.Medium} variant={ButtonVariant.White} href={getMembershipPagePath(tenant)}>
				<Formatted text={translate("fathersFamilyMoreInfo")} />
			</Link>
			<Button
				size={ButtonSize.Medium}
				variant={ButtonVariant.OutlinedWhite}
				disabled={Auth.signedIn}
				onclick={(): void => {
					Auth.openAuthenticationModal(AuthenticationModalKind.Register, {});
				}}
			>
				<Formatted text={translate("fathersFamilyJoin")} />
			</Button>
		{/snippet}
	</ImageSection>
	<ImageSection
		class="w-full !h-[75vh] lg:!col-span-1"
		innerClass="px-0"
		sources={{
			default: wholesaleImageXs,
			">sm": wholesaleImageSm,
			">2xl": wholesaleImage2xl,
			">3xl": wholesaleImage3Xl,
		}}
		media="lg:object-[50%_0%] 2xl:object-[50%_25%]"
		heading={{ text: translate("wholesale"), level: 2 }}
		paragraph={translate("wholesaleInfo")}
		darkOverlay
	>
		{#snippet actions()}
			<Link size={ButtonSize.Medium} variant={ButtonVariant.White} href={getWholesalePath(tenant)}>
				<Formatted text={translate("moreInfo")} />
			</Link>
			<Link
				size={ButtonSize.Medium}
				variant={ButtonVariant.OutlinedWhite}
				href="{getWholesalePath(tenant)}{getJoinWholesaleAnchor(tenant.locale)}"
			>
				<Formatted text={translate("wholeSaleJoin")} />
			</Link>
		{/snippet}
	</ImageSection>
</div>
